import "./Home.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import CinematicVision from "./sections/CinematicVision";
import Manifesto from "./sections/Manifesto";
import TheDesignFluxEdge from "./sections/TheDesignFluxEdge";
import TheVisualFeed from "./sections/TheVisualFeed";
import GlobalPartners from "./sections/GlobalPartners";
import ReadyToCollaborate from "./sections/ReadyToCollaborate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PrimaryNavigation />
      <CinematicVision />
      <Manifesto />
      <TheDesignFluxEdge />
      <TheVisualFeed />
      <GlobalPartners />
      <ReadyToCollaborate />
      <Footer />
    </div>;
}